import * as React from 'react';
import { getWindow } from '../../../window/Window';

const ContinueWithoutLogin: React.FC = () => {
  continueWithoutLogin();
  return null;
};

const continueWithoutLogin = () => {
  if (getWindow().parent.continueWithoutLogin) {
    getWindow().parent.continueWithoutLogin();
  }
};

export { ContinueWithoutLogin };
